module.exports = __webpack_public_path__ + "img/an-evengroup-company_logo-blanco.4a5ba027.svg";